import { type QueryKey } from '@tanstack/react-query'
import { buildQueryKey, OperationIds } from '@opallabs/api'
import {
  boardObjectsIdentifiers,
  readBoard,
  readBoardObjects,
} from '@opallabs/api/v3'
import { queryKeys } from './src/queries/queryKeys'

export { queryKeys }

// The monolith posts these keys in `asgard:queries:invalidate` messages. Its
// CoffeeScript is not type-checked, so a renamed or reshaped key fails only at
// runtime; `monolith-exports.tests.ts` pins them.

/**
 * Keys for a board's document, the objects of all its collections, and its
 * collection list.
 */
export const boardRefreshKeys = (
  workspaceUuid: string,
  boardId: string
): QueryKey[] => [
  readBoard.queryKey(queryKeys.boardIdentifiers(workspaceUuid, boardId)),
  readBoardObjects.queryKey(
    boardObjectsIdentifiers.board({ workspaceUuid, boardId })
  ),
  queryKeys.boardCollections(workspaceUuid, boardId),
]

/**
 * Prefixes of every board document in a workspace, and of its board lists and
 * board side queries. Not the boards' objects or workflows.
 */
export const workspaceBoardsRefreshKeys = (
  workspaceUuid: string
): QueryKey[] => [
  buildQueryKey({
    resource: 'board',
    operationId: OperationIds.ReadBoardV3,
    identifiers: { workspaceUuid },
  }),
  queryKeys.boards(workspaceUuid),
]
